import { useEffect, useState } from "react";
import { getConsent, setConsent } from "../lib/consent";
import {
  loadGoogleAnalytics,
  updateGoogleConsent,
} from "../lib/loadAnalytics";

export default function CookiePreferencesModal({ isOpen, onClose }) {
    const [analytics, setAnalytics] = useState(false);
    const [marketing, setMarketing] = useState(false);

    useEffect(() => {
        if (!isOpen) return;

        const consent = getConsent();
        setAnalytics(!!consent?.analytics);
        setMarketing(!!consent?.marketing);
    }, [isOpen]);

    if (!isOpen) return null;

    const savePreferences = () => {
        const consent = {
            essential: true,
            analytics,
            marketing,
        };

        setConsent(consent);

        if (analytics || marketing) {
            loadGoogleAnalytics();
        }

        updateGoogleConsent(consent);
        onClose();
    };

    const acceptAll = () => {
        const consent = {
            essential: true,
            analytics: true,
            marketing: true,
        };

        setAnalytics(true);
        setMarketing(true);
        setConsent(consent);
        loadGoogleAnalytics();
        updateGoogleConsent(consent);
        onClose();
    };

    const refuseAll = () => {
        const consent = {
            essential: true,
            analytics: false,
            marketing: false,
        };

        setAnalytics(false);
        setMarketing(false);
        setConsent(consent);
        updateGoogleConsent(consent);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-4">
            <div className="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-2xl">
                <div className="flex items-start justify-between gap-4">
                    <div>
                        <h2 className="text-xl font-bold text-gray-900">
                            Préférences de cookies
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Gérez ici les cookies utilisés sur le site. Les cookies essentiels
                            sont toujours actifs car ils sont nécessaires au fonctionnement du site.
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="rounded-lg px-3 py-1 text-sm text-gray-500 hover:bg-gray-100"
                        aria-label="Fermer"
                    >
                        ✕
                    </button>
                </div>

                <div className="mt-6 space-y-4">
                    <div className="rounded-xl border border-gray-200 p-4">
                        <div className="flex items-start justify-between gap-4">
                            <div>
                                <h3 className="font-semibold text-gray-900">Cookies essentiels</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.
                                </p>
                            </div>

                            <div className="rounded-full bg-gray-200 px-3 py-1 text-xs font-medium text-gray-700">
                                Toujours actifs
                            </div>
                        </div>
                    </div>

                    <div className="rounded-xl border border-gray-200 p-4">
                        <div className="flex items-start justify-between gap-4">
                            <div className="pr-4">
                                <h3 className="font-semibold text-gray-900">Mesure d’audience</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Permettent de mesurer la fréquentation et l’utilisation du site,
                                    par exemple avec Google Analytics.
                                </p>
                            </div>

                            <label className="inline-flex cursor-pointer items-center">
                                <input
                                    type="checkbox"
                                    checked={analytics}
                                    onChange={(e) => setAnalytics(e.target.checked)}
                                    className="h-5 w-5 rounded"
                                />
                            </label>
                        </div>
                    </div>

                    <div className="rounded-xl border border-gray-200 p-4">
                        <div className="flex items-start justify-between gap-4">
                            <div className="pr-4">
                                <h3 className="font-semibold text-gray-900">Marketing</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Permettent de proposer des contenus, publicités ou suivis marketing
                                    adaptés à votre navigation.
                                </p>
                            </div>

                            <label className="inline-flex cursor-pointer items-center">
                                <input
                                    type="checkbox"
                                    checked={marketing}
                                    onChange={(e) => setMarketing(e.target.checked)}
                                    className="h-5 w-5 rounded"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex flex-wrap gap-3">
                    <button
                        onClick={acceptAll}
                        className="rounded-xl bg-black px-4 py-2 text-sm font-medium text-white hover:opacity-90"
                    >
                        Tout accepter
                    </button>

                    <button
                        onClick={refuseAll}
                        className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50"
                    >
                        Tout refuser
                    </button>

                    <button
                        onClick={savePreferences}
                        className="rounded-xl border border-black px-4 py-2 text-sm font-medium text-black hover:bg-gray-100"
                    >
                        Enregistrer mes choix
                    </button>
                </div>
            </div>
        </div>
    );
}